export enum FormSectionHeadingType {
  Compact = 'compact',
  Screen = 'screen',
}
